import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const EligibilityResultWrapperAgreementTextStyle: StyleExtend<Theme> = {
  textAlign: 'center',
  maxWidth: '342px',
  display: 'inline-block',
  margin: '0 auto',
  '& .MuiLink-root': {
    color: (theme) => theme.palette.secondary.main,
    textDecorationColor: (theme) => theme.palette.secondary.main,
  },
};
